import React from "react"
import BackgroundImage from 'gatsby-background-image'

import { graphql, Link } from "gatsby"
import { slugify } from "../../util/utilityFunctions"

import Layout from "../components/Layout"
import SEO from "../components/SEO"
import Tag from "../components/TagNew"

import '../style/prose-overide.css'

const SinglePost = ({data, pageContext}) => {

    const meta = data.markdownRemark
    const post = data.markdownRemark.frontmatter
    const time = meta.timeToRead

    return (
        <Layout pageTitle={post.title}>
            <SEO title={post.title}/>
                <BackgroundImage
                    Tag="section"
                    role="img"
                    aria-label="Art-Directed Fullscreen Background"
                    className={'w-full lg:h-190 md:h-96 sm:h-76 h-72 relative dark:bg-BaseDark'}
                    fluid={post.image.childImageSharp.fluid}>
                    <div className="absolute bottom-0 flex flex-col items-start mb-12 md:mb-20 lg:mb-48">

                            <span className="px-6 py-1 text-xl font-bold leading-tight tracking-tight transition-colors duration-500 lg:text-6xl md:text-5xl sm:text-4xl dark:text-BaseDark text-BaseLight dark:bg-BaseLight bg-BaseDark">{post.title}</span>

                            <span className="px-6 py-1 text-sm font-semibold transition-colors duration-500 md:font-bold md:text-xl dark:text-BaseLight text-BaseDark dark:bg-BaseDark bg-BaseLight py2"><span className="hidden sm:inline-block">Posted on&nbsp;</span>{post.date}. A&nbsp;
                            {time===1 && 'one '}
                            {time===2 && 'two '}
                            {time===3 && 'three '}
                            {time===4 && 'four '}
                            {time===5 && 'five '}
                            {time===6 && 'six '}
                            {time===8 && 'eight '}
                            {time===9 && 'nine '}
                            {time===10 && 'ten '}
                            {time===11 && 'eleven '}
                            {time===12 && 'twelve '}
                            {time===13 && 'thirteen '}
                            {time===14 && 'fourteen '}
                            {time===15 && 'fifteen '} minute read</span>
                            <span className="hidden px-6 py-2 text-sm font-semibold transition-colors duration-500 md:block md:font-bold md:text-xl dark:text-BaseLight text-BaseDark dark:bg-BaseDark bg-BaseLight py2">
                                <ul className="flex items-center">
                                    {post.tags.map(tag => (
                                        <li key={tag}>
                                            <Link to={`/projects/${slugify(tag)}`}>
                                                <Tag tag={tag}/>
                                            </Link>
                                        </li>
                                    ))}
                                </ul>
                            </span>

                    </div>
                </BackgroundImage>

                <div className="mx-auto mt-12 prose md:prose-xl lg:prose-2xl dark:text-BaseLight text-BaseDark font-ibm" dangerouslySetInnerHTML={{ __html: data.markdownRemark.html }}/>

        </Layout>

    )
}

export const postQuery = graphql`
    query blogPostBySlug($slug: String!){
        markdownRemark(fields: {slug: {eq: $slug}}) {
            html
            id
            timeToRead
            frontmatter {
                title
                author
                date(formatString: "MMM do YYYY")
                tags
                image {
                    childImageSharp {
                    fluid(grayscale: false, maxWidth: 700, webpQuality: 90, toFormat: WEBP) {
                        ...GatsbyImageSharpFluid
                        }
                    }
                }
            }
        }
    }
`

export default SinglePost